import { useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { Asset } from 'src/models';
import { object, string } from 'yup';
import { isSmallMobileDeviceQuery } from 'src/util/responsive';
import { LocationDetailsTextField } from '../atomic-components/LocationDetailsTextField';
import { DistrictDetailsTextField } from '../atomic-components/DistrictDetailsTextField';
import { CityDetailsTextField } from '../atomic-components/CityDetailsTextField';
import { LocationPhotosImageSelector } from '../atomic-components/LocationPhotosImageSelector';

export const validationSchemaLocationDetails = object({
  locationDescription: string().required('Location description is required'),
});

export const getInitValuesLocationDetails = (asset: Asset | undefined) => {
  return {
    locationDescription: asset?.descriptions?.locationDetails || '',
  };
};

interface Props {
  disabled: boolean;
}

export const AssetLocationDetails: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const isSmallMobileDevice = useMediaQuery(isSmallMobileDeviceQuery);

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.main.locationdetails.title')}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isSmallMobileDevice ? '1fr' : '1fr 1fr',
          columnGap: isSmallMobileDevice ? 'unset' : '1.5rem',
        }}
      >
        <div>
          <LocationDetailsTextField disabled={disabled} />
          <CityDetailsTextField disabled={disabled} />
          <DistrictDetailsTextField disabled={disabled} />
        </div>
        <LocationPhotosImageSelector disabled={disabled} />
      </div>
    </LaunchpadCard>
  );
};
